module.exports = __webpack_public_path__ + "img/pdf-icon.648da218.svg";